/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import * as Sentry from '@sentry/angular';
import packageInfo from '../package.json';
import { environment } from './environments/environment';

import { AmplitudeService } from '@inyova/inyova-shared';

if (environment.name === 'staging' || environment.name === 'production') {
  Sentry.init({
    dsn: 'https://3bbb77d787ae4b1eaee08cbfe230eaf1@o1009232.ingest.sentry.io/5977520',
    environment: environment.name,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    ignoreErrors: ['.parentNode.insertBefore'],
    release: packageInfo.version,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

if (environment.production) {
  enableProdMode();

  const loadError = function (err: any) {
    throw new Error(`Failed to load ${err.target.src}`);
  };
  const gtm = document.createElement('script');
  gtm.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-NF2PCN7');`;
  gtm.onerror = loadError;
  document.head.appendChild(gtm);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then((ref) => {
    const amplitudeService = ref.injector.get(AmplitudeService);
    amplitudeService.init(environment.amplitudeApiKey, 'web');
  })
  .catch((err) => console.error(err));
